import logger from "../common/Logger";
import CoreService from "./CoreService";
import ApiService from "./ApiService";

class ApiKeyService {
    /**
     * Create a new API key.
     *
     * @param callback {Function}
     */
    createKey = (callback) => {
        ApiService.makeRequest(`/api/account/tokens`, {
            type: "POST",
            success: (key) => {
                callback(key);
            },
            error: (result, err) => {
                if (err) logger.error(err);
                CoreService.showPassiveError(`Unable to create API key.`);
            }
        });
    };

    /**
     * Fetch the list of API keys.
     *
     * @param callback {Function}
     */
    fetchKeys = (callback) => {
        ApiService.makeRequest("/api/account/tokens", {
            type: "GET",
            success: (events) => {
                callback(events);
            },
            error: (result, err) => {
                if (err) logger.error(err);
                CoreService.showPassiveError('Unable to list API keys.');
            }
        });
    };

    /**
     * Delete the API key with the given token ID.
     *
     * @param tokenId {String}
     * @param callback {Function}
     */
    deleteKey = (tokenId, callback) => {
        ApiService.makeRequest(`/api/account/tokens/${tokenId}`, {
            type: "DELETE",
            success: () => {
                callback();
            },
            error: (result, err) => {
                if (err) logger.error(err);
                CoreService.showPassiveError(`Unable to delete API key.`);
            }
        });
    };
}

export default new ApiKeyService();



// WEBPACK FOOTER //
// ./src/modules/service/ApiKeyService.js